import { render, staticRenderFns } from "./InvestorSavingItem.vue?vue&type=template&id=6bb92e96&scoped=true&"
import script from "./InvestorSavingItem.vue?vue&type=script&lang=js&"
export * from "./InvestorSavingItem.vue?vue&type=script&lang=js&"
import style0 from "./InvestorSavingItem.vue?vue&type=style&index=0&id=6bb92e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb92e96",
  null
  
)

export default component.exports